import type { ParsedLocation } from '@tanstack/react-router'

import type { TRoutes } from '~/types/routes'

export const LS_LAST_VISITED_PATHNAME = 'lingo-cards-last-visited-pathname'

const sensitiveHrefPattern = /(?:secret|token|password|payment_intent)/i

const isSkippablePathname = (pathname: string) => {
  if (pathname === ('/' satisfies TRoutes)) return true
  if (pathname.startsWith('/auth' satisfies TRoutes)) return true
  if (pathname.startsWith('/subscription/checkout' satisfies TRoutes)) return true
  if (pathname === ('/token-to-ls' satisfies TRoutes)) return true
  return false
}

export const isRestorableInternalAppHref = (pathname: string, searchStr?: string) => {
  if (searchStr && sensitiveHrefPattern.test(searchStr)) return false

  if (isSkippablePathname(pathname)) return false

  return true
}

export const shouldPersistLastVisitedRoute = (location: ParsedLocation) => {
  if (location.external) return false

  return isRestorableInternalAppHref(location.pathname, location.searchStr)
}

export const persistLastVisitedRouteIfEligible = (location: ParsedLocation) => {
  if (!shouldPersistLastVisitedRoute(location)) return

  localStorage.setItem(LS_LAST_VISITED_PATHNAME, location.pathname)
}

export const readPersistedLastVisitedHref = (): string | null => {
  const pathname = localStorage.getItem(LS_LAST_VISITED_PATHNAME)

  if (!pathname || !isRestorableInternalAppHref(pathname)) return null

  return pathname
}

export const clearLastVisitedRoute = () => localStorage.removeItem(LS_LAST_VISITED_PATHNAME)
